<template>
  <div>
    <button
      type="button"
      class="btn btn-outline-dark btn-sm"
      @click="addResumeModal"
    >
      新增履歷
    </button>
    <div
      id="addResumeModal"
      class="modal fade bd-example-modal-xl"
      data-focus="false"
      data-keyboard="false"
      data-backdrop="static"
    >
      <div
        class="modal-dialog modal-dialog-scrollable modal-lg"
      >
        <div class="modal-content">
          <button
            type="button"
            class="close text-right"
            style="margin-right: 6px"
            data-dismiss="modal"
            aria-label="Close"
          >
            <span style="color: #fff" aria-hidden="true">&times;</span>
          </button>
          <div class="modal-body">
            <div class="title">
              <h2>
                <i class="fa fa-briefcase icon1" aria-hidden="true"></i>
                <span class="sr-only">Resume</span>
              </h2>
              <h4>應聘者履歷</h4>
            </div>
            <div class="form-content">
              <ValidationObserver ref="addResume" v-slot="{ handleSubmit }">
                <form
                  @submit.prevent="handleSubmit(submitResume)"
                  @reset.prevent="reset"
                >
                  <div class="row">
                    <div class="col-sm-12 col-md-3">
                      <ValidationProvider rules="required" v-slot="{ errors }">
                        <input
                          type="text"
                          placeholder="姓(必填)"
                          v-model="resume.LastName"
                        />
                        <span
                          v-if="errors[0] && !is_composing"
                          class="text-danger"
                          style="margin-top: -10px"
                        >
                          {{ errors[0] }}
                        </span>
                      </ValidationProvider>
                    </div>
                    <div class="col-sm-12 col-md-3">
                      <ValidationProvider rules="required" v-slot="{ errors }">
                        <input
                          type="text"
                          placeholder="名(必填)"
                          v-model="resume.FirstName"
                        />
                        <span
                          v-if="errors[0] && !is_composing"
                          class="text-danger"
                        >
                          {{ errors[0] }}
                        </span>
                      </ValidationProvider>
                    </div>
                    <div class="col-sm-12 col-md-6">
                      <input
                        type="text"
                        placeholder="英文姓名"
                        v-model="resume.EnglishName"
                      />
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-sm-12 col-md-3">
                      <ValidationProvider
                        rules="required|numeric|cellPhone:10"
                        v-slot="{ errors }"
                      >
                        <input-facade
                          mask="####-###-###"
                          placeholder="手機(必填)"
                          v-model.trim="resume.MobilePhone"
                        />
                        <span
                          v-if="errors[0] && !is_composing"
                          class="text-danger"
                        >
                          {{ errors[0] }}
                        </span>
                      </ValidationProvider>
                    </div>
                    <div class="col-sm-12 col-md-3">
                      <input-facade
                        mask="(##)###-####"
                        placeholder="市話"
                        :masked="true"
                        v-model="resume.Phone"
                      />
                    </div>
                    <div class="col-sm-12 col-md-6">
                      <ValidationProvider
                        rules="required|email"
                        v-slot="{ errors }"
                      >
                        <input
                          type="text"
                          placeholder="電子信箱(必填)"
                          v-model="resume.Email"
                        />
                        <span
                          v-if="errors[0] && !is_composing"
                          class="text-danger"
                        >
                          {{ errors[0] }}
                        </span>
                      </ValidationProvider>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-sm-12 col-md-4">
                      <select v-model="resume.Nationality">
                        <option value="本國人士">本國人士</option>
                        <option value="外籍人士">外籍人士</option>
                      </select>
                    </div>
                    <div class="col-sm-12 col-md-4">
                      <select
                        v-if="
                          resume.Nationality === '外籍人士' ||
                          resume.Nationality === null
                        "
                        v-model="resume.Country"
                      >
                        <option :value="null" disabled>國籍(請選擇)</option>
                        <option
                          v-for="item in nationalityList"
                          :key="item.Guid"
                          :value="item.Name"
                        >
                          {{ item.Name }}
                        </option>
                      </select>
                      <input
                        v-if="resume.Nationality === '本國人士'"
                        type="text"
                        disabled
                        v-model="resume.Country"
                      />
                    </div>
                    <div class="col-sm-12 col-md-4">
                      <input
                        v-if="resume.Nationality === '本國人士'"
                        type="text"
                        placeholder="身份證字號"
                        v-model="resume.IdNo"
                      />
                      <input
                        v-else
                        type="text"
                        placeholder="居留證號碼"
                        v-model="resume.ResidentCertificateIdNo"
                      />
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-sm-12 col-md-4">
                      <ValidationProvider rules="required" v-slot="{ errors }">
                        <select v-model="resume.Gender">
                          <option :value="null" disabled>性別(必填)</option>
                          <option value="男">男</option>
                          <option value="女">女</option>
                        </select>
                        <span
                          v-if="errors[0] && !is_composing"
                          class="text-danger"
                        >
                          {{ errors[0] }}
                        </span>
                      </ValidationProvider>
                    </div>
                    <div class="col-sm-12 col-md-4">
                      <select v-model="resume.MaritalStatus">
                        <option :value="null" disabled>婚姻狀態(請選擇)</option>
                        <option
                          v-for="item in maritalStatusList"
                          :key="item.Guid"
                          :value="item.Name"
                        >
                          {{ item.Name }}
                        </option>
                      </select>
                    </div>
                    <div class="col-sm-12 col-md-4">
                      <ValidationProvider rules="required" v-slot="{ errors }">
                        <date-picker
                          class="w-100 date-select-style"
                          type="date"
                          :disabled-date="disabledAfterToday"
                          placeholder="出生日期(必填)"
                          v-model="resume.Birthday"
                        ></date-picker>
                        <span
                          v-if="errors[0] && !is_composing"
                          class="text-danger"
                        >
                          {{ errors[0] }}
                        </span>
                      </ValidationProvider>
                    </div>
                  </div>
                  <div v-if="resume.Gender === '男'" class="row">
                    <div class="col-sm-12 col-md-4">
                      <select v-model="resume.MilitaryStatus">
                        <option :value="null" disabled>兵役狀態</option>
                        <option value="役畢">役畢</option>
                        <option value="待役">待役</option>
                        <option value="免役">免役</option>
                        <option value="服役中">服役中</option>
                      </select>
                    </div>
                    <template v-if="resume.MilitaryStatus === '免役'">
                      <div class="col-sm-12 col-md-8">
                        <input
                          type="text"
                          placeholder="免疫原因"
                          v-model="resume.ExemptMilitaryServiceReason"
                        />
                      </div>
                    </template>
                    <template v-else>
                      <div class="col-sm-12 col-md-4">
                        <date-picker
                          class="w-100 date-select-style"
                          type="date"
                          placeholder="服役期間(起)"
                          v-model="resume.MilitaryServiceStartDate"
                        ></date-picker>
                      </div>
                      <div class="col-sm-12 col-md-4">
                        <date-picker
                          class="w-100 date-select-style"
                          type="date"
                          placeholder="服役期間(訖)"
                          v-model="resume.MilitaryServiceEndDate"
                        ></date-picker>
                      </div>
                    </template>
                  </div>
                  <div class="row">
                    <div class="col-sm-12 col-md-4">
                      <input
                        type="text"
                        disabled
                        v-model="resume.PositionDesired"
                      />
                    </div>
                    <div class="col-sm-12 col-md-4">
                      <input-facade
                        mask="###"
                        placeholder="身高"
                        v-model.number="resume.Height"
                      />
                    </div>
                    <div class="col-sm-12 col-md-4">
                      <input-facade
                        mask="###"
                        placeholder="體重"
                        v-model.number="resume.Weight"
                      />
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-sm-12 col-md-4">
                      <select v-model="resume.EmploymentStatus">
                        <option :value="null" disabled>就業狀態</option>
                        <option value="在職中">在職中</option>
                        <option value="待業中">待業中</option>
                        <option value="就學中">就學中</option>
                      </select>
                    </div>
                    <template v-if="resume.DisabilityIdentification">
                      <div class="col-sm-12 col-md-4">
                        <select v-model="resume.DisabilityIdentification">
                          <option :value="false">未領有身心障礙手冊</option>
                          <option :value="true">領有身心障礙手冊</option>
                        </select>
                      </div>
                      <div class="col-sm-12 col-md-4">
                        <select v-model="resume.DisabilityLevel">
                          <option :value="null" disabled>身心障礙類別</option>
                          <option value="輕度">輕度</option>
                          <option value="中度">中度</option>
                          <option value="重度">重度</option>
                        </select>
                      </div>
                    </template>
                    <template v-else>
                      <div class="col-sm-12 col-md-8">
                        <select v-model="resume.DisabilityIdentification">
                          <option :value="false">未領有身心障礙手冊</option>
                          <option :value="true">領有身心障礙手冊</option>
                        </select>
                      </div>
                    </template>
                  </div>
                  <div class="row">
                    <div class="col-sm-12 col-md-4">
                      <input
                        type="text"
                        placeholder="郵遞區號"
                        v-model="resume.PostCode"
                      />
                    </div>
                    <div class="col-sm-12 col-md-8">
                      <input
                        type="text"
                        placeholder="聯絡地址"
                        v-model="resume.ContactAddress"
                      />
                    </div>
                  </div>
                  <div class="text-center">
                    <button type="submit" class="btn submit-btn">送出</button>
                  </div>
                </form>
              </ValidationObserver>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* global $ */
import moment from "moment";

export default {
  name: "CreateResumeModal",

  data() {
    return {
      // compositionstart & compositionend
      is_composing: false,

      resume: {},
      api: null,

      // 國家列表
      nationalityList: [],
      // 婚姻狀態列表
      maritalStatusList: [],
    };
  },

  watch: {
    "resume.Nationality": function (e) {
      this.resume.Country = e === "本國人士" ? "中華民國" : null;
    },
  },

  methods: {
    // 日期不得大於今日
    disabledAfterToday(date) {
      const today = new Date();
      today.setHours(0, 0, 0, 0);
      return date > today;
    },

    // 新增履歷 Modal
    addResumeModal() {
      this.resume = {
        // 固定值(不可改)
        InfomationSource: "內部同仁推薦",
        StartWorkingDateOptions: "-",
        ExpectedWorkPlace: [],
        EmergencyContact: "-",
        EmergencyContactRelationship: "-",
        EmergencyContactPhone: "-",
        Cnc: false,
        PositionDesired: JSON.parse(localStorage.getItem("ResumeCard"))
          .PositionName,
        ////////////////////
        Nationality: "本國人士",
        Country: "中華民國",
        Gender: null,
        Birthday: null,
        MaritalStatus: null,
        MilitaryStatus: null,
        EmploymentStatus: null,
        DisabilityIdentification: false,
        DisabilityLevel: null,
      };
      this.$refs.addResume.reset();
      $("#addResumeModal").modal("show");
    },

    // 新增履歷 API
    submitResume() {
      const vm = this;

      const data = {
        ...vm.resume,
        Name: null,
        ManpowerDemandNo: JSON.parse(localStorage.getItem("ResumeCard"))
          .DemandNo,
        CreateUser: vm.$cookies.get("userId"),
      };

      data.Birthday = moment(data.Birthday).format("YYYY-MM-DD");

      data.Height = data.Height ? Number(data.Height) : null;
      data.Weight= data.Weight ? Number(data.Weight) : null;

      switch (JSON.parse(localStorage.getItem("ResumeCard")).ResumeType) {
        case "Main":
          vm.api = `${window.endpoints.api}/Recruitment/MainResumeFromResumeView`;
          data.Name = data.LastName + data.FirstName;
          break;
        case "IDL":
          vm.api = `${window.endpoints.api}/ResumeModule/EpistarResumeIDLFromResumeView`;
          break;
        case "DL":
          vm.api = `${window.endpoints.api}/ResumeModule/EpistarResumeDLFromResumeView`;
          break;
      }

      vm.$store.dispatch("updateLoading", true);
      vm.$http
        .post(vm.api, data)
        .then((response) => {
          if (response.status === 200) {
            vm.$store.dispatch("updateLoading", false);
            $("#addResumeModal").modal("hide");
            vm.$notify({
              title: "成功",
              message: "履歷新增成功",
              type: "success",
              duration: 3500,
            });
            this.$emit("getResumeList");
          }
        })
        .catch((error) => {
          vm.$store.dispatch("updateLoading", false);
          vm.$notify({
            title: "失敗",
            message: error.response.data,
            type: "error",
            duration: 5000,
          });
        });
    },
  },
  created() {
    this.get_nationality()
      .then((result) => {
        this.nationalityList = result;
      })
      .catch((error) =>
        this.$notify({
          title: "國家列表取得失敗",
          message: error.response.data,
          type: "error",
          duration: 3500,
        })
      );

    this.get_marital_status()
      .then((result) => {
        this.maritalStatusList = result;
      })
      .catch((error) =>
        this.$notify({
          title: "婚姻狀態列表取得失敗",
          message: error.response.data,
          type: "error",
          duration: 3500,
        })
      );
  },
};
</script>

<style lang="scss" scoped>
#addResumeModal {
  .modal-content {
    background-image: url(~@/assets/img/card_bg.png);
    background-position: top;
    background-size: cover;
    &:after {
      content: "";
      position: absolute;
      left: 0;
      right: 0;
      top: 0;
      bottom: 0;
      background-color: rgba(83, 128, 247, 0.85);
      background-color: rgba(59, 61, 64, 0.85);
      z-index: 1;
    }
    & > button {
      z-index: 2;
    }
    .modal-body {
      z-index: 2;

      .title {
        color: #fff;
        text-align: left;
        position: relative;
        font-family: Arial, Helvetica, sans-serif;
        font-weight: bolder;
        padding-left: 15px;

        &::after {
          content: "";
          position: absolute;
          background-color: #5380f7;
          width: 300px;
          height: 15px;
          left: 0;
          bottom: 7px;
        }

        h2,
        h4 {
          display: inline-block;
          position: relative;
          z-index: 2;
          text-shadow: 2px 2px 5px rgba(136, 107, 107, 0.2);
          letter-spacing: 1px;
        }

        h2 {
          margin-right: 10px;
        }
      }
      .form-content {
        background-color: #fff;
        padding: 20px;
        border-radius: 5px;
      }
    }
  }

  .form-content {
    input[type="text"],
    input[type="number"],
    select {
      width: 100%;
      border: none;
      background: #f5f5f5;
      margin: 15px 0 10px 0;
      padding: 6px 5px 6px 10px;
      letter-spacing: 1px;
      border-radius: 3px;
    }
    input[type="text"]::placeholder,
    input[type="number"]::placeholder {
      font-family: "微軟正黑體", sans-serif;
      letter-spacing: 1px;
    }
    input[type="text"]:focus,
    input[type="number"]:focus {
      outline: 0;
    }

    .submit-btn {
      margin-top: 30px;
      border-radius: 3px;
      color: #eee;
      letter-spacing: 2px;
      padding: 6px 30px;
      background-color: #5380f7;
    }

    /deep/ .date-select-style {
      .mx-input-wrapper {
        width: 100%;
        border: none;
        background: #f5f5f5;
        margin: 15px 0 10px 0;
        padding: 6px 5px 6px 10px;
        .mx-input {
          border: none;
          padding: 0;
          box-shadow: none;
          height: 24px;
          letter-spacing: 1px;
        }
        .mx-input::placeholder {
          font-family: "微軟正黑體", sans-serif;
          font-size: 16px;
          letter-spacing: 1px;
        }
      }
    }
  }
}
</style>
